/**
 * Canonical client auth capability helpers.
 *
 * Purpose:
 * - distinguish "token exists" from "may call strict-auth endpoints"
 * - keep anonymous Better Auth sessions out of strict-auth queries/mutations
 * - provide one reusable signal for hooks, route guards, and UI branching
 */

export type AuthCapability = "loading" | "anonymous" | "authenticated";

export interface AuthCapabilityInput {
	loading: boolean;
	isRealUser: boolean;
}

export function getAuthCapability({
	loading,
	isRealUser,
}: AuthCapabilityInput): AuthCapability {
	if (loading) return "loading";
	return isRealUser ? "authenticated" : "anonymous";
}

export function canAccessStrictAuthEndpoints(
	input: AuthCapabilityInput,
): boolean {
	return getAuthCapability(input) === "authenticated";
}
